import { z } from "zod";

/** Slice-keyed composition descriptors (e.g. `{ poolConfig: {signal: default} }`).
 * Generic map of slice → toggle → default so a future Config slice appears as
 * another key without changing the endpoint or the UI plumbing. */
export const CompositionDescriptorsSchema = z.record(
  z.string(),
  z.record(z.string(), z.boolean()),
);

export type CompositionDescriptors = z.infer<
  typeof CompositionDescriptorsSchema
>;
